import { Col, Container, Row } from 'react-bootstrap'
import styled from 'styled-components'
export const ExperienceTimeCountCard = styled(Col)`
    padding: 1rem;
    background-color: ${({ theme }) => theme.color.third};
    border-radius:5px;
    text-align: center;

    >h2{
        color: ${({ theme }) => theme.color.first};
        font-family:${({ theme }) => theme.font.first};
        font-weight:700;
    }
    >p{
        font-family:${({ theme }) => theme.font.second};
        font-weight:500;
        color: ${({ theme }) => theme.color.sixth};
    }

`